import { Component } from '@angular/core';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';

@Component({
    selector: 'vacation-pay-display-component',
    template: `
        <div>
            {{ value ? (value | i18nNum) + '%' : '-' }}
        </div>
    `,
})
export class VacationPayDisplayComponent implements DisplayComponentInterface {
    value = '';
}
